export default __webpack_public_path__ + "static/media/bjoern.d36592be.png";